module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-navy-2-2a6966fe7327bab2ef4f12d5d670161e.webp";